import { Field, FieldProps, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import FormikTextbox from "src/components/Common/UI/Formik/FormikTextbox";
import FormikDropdown from "src/components/Common/UI/Formik/FormkDropdown";
import * as Yup from "yup";
import DatePicker from "react-datepicker";


const DataLineBillingForm = ({ type, initialValues, onSubmit }: DataLineBillingFormProps) => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    const validationSchema= Yup.object({
      billYear: Yup.string()
      .required('Το πεδίο είναι υποχρεωτικό')
      .matches(/^\d{4}$/, 'Το έτος πρέπει να είναι τετραψήφιος αριθμός')
      .test('is-valid-year', 'Το έτος πρέπει να είναι μεταξύ 1900 και του τρέχοντος έτους', (value) => {
        const year = parseInt(value, 10);
        return year >= 1900 && year <= currentYear;
      }),
      billMonth: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
     
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          if (type === "create") {
            onSubmit(values, formikHelpers);
          } else {
            onSubmit(
              values, formikHelpers
            );
          }
        }}
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
          <Form>
            <Container fluid className="p-0">
              <Row>

              <Col xs={6}>
                <FormikDropdown
                  label={"Μήνας Λογαριασμού"}
                  fieldName={"billMonth"}
                >
                   <option value="">{t("Επιλέξτε Μήνα")}</option>
                   <option value="1">{t("Ιανουάριος")}</option>
                   <option value="2">{t("Φεβρουάριος")}</option>
                   <option value="3">{t("Μάρτιος")}</option>
                   <option value="4">{t("Απρίλιος")}</option>
                   <option value="5">{t("Μάιος")}</option>
                   <option value="6">{t("Ιούνιος")}</option>
                   <option value="7">{t("Ιούλιος")}</option>
                   <option value="8">{t("Αύγουστος")}</option>
                   <option value="9">{t("Σεπτέμβριος")}</option>
                   <option value="10">{t("Οκτώβριος")}</option>
                   <option value="11">{t("Νοέμβριος")}</option>
                   <option value="12">{t("Δεκέμβριος")}</option>
                </FormikDropdown>
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Κόστος (χωρίς ΦΠΑ)"} 
                  fieldName={"cost"}
                />
              </Col>

              <Col xs={6}>
                <FormikTextbox 
                  label={"Έτος Λογαριασμού"} 
                  fieldName={"billYear"}
                />
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Ελέγχου")}
                </label>
                <Field 
                  name="dbDate"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Χρέωσης Από")}
                </label>
                <Field 
                  name="dbDateFrom"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>             
              </Col>

              <Col xs={6}>
                <label className="form-label">
                {t("Ημερομηνία Χρέωσης Έως")}
                </label>
                <Field 
                  name="dbDateTo"
                >
                  {({ field, form }: FieldProps<Date>) => (
                    <DatePicker
                      id="date"
                      {...field}
                      selected={field.value}
                      onChange={(date) => form.setFieldValue(field.name, date)}
                      value={field.value ? field.value.toLocaleDateString('el-GR').split('/').join('-') : ''}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                    />
                  )}
                </Field>             
              </Col>

              <Col xs={6}>
                <FormikDropdown
                  label={"Άκρο"}
                  fieldName={"lEnd"}
                >
                   <option value="">{t("Επιλέξτε Άκρο")}</option>
                   <option value="1">{t("Α")}</option>
                   <option value="2">{t("Β")}</option>
                   <option value="3">{t("Α,Β")}</option>
                </FormikDropdown>
              </Col>
            
              </Row>
            </Container>

            <div className="mb-3">
              <Button
                type="submit"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
              >
                {type == "create" ? t("Δημιουργία") : t("Αποθήκευση")}
              </Button>
            </div>
          </Form>
      )}
      </Formik>
  )
}

export default DataLineBillingForm;

type CreateOrEdit =
  | {
      type: "create";
      initialValues: ICreateDataLineBillingForm;
      onSubmit: (
        values: ICreateDataLineBillingForm,
        formikHelpers: FormikHelpers<ICreateDataLineBillingForm>
      ) => void;
    }
  | {
      type: "edit";
      initialValues: IEditDataLineBillingForm;
      onSubmit: (
        values: IEditDataLineBillingForm,
        formikHelpers: FormikHelpers<IEditDataLineBillingForm>
      ) => void;
    };

type DataLineBillingFormProps = CreateOrEdit;